import { Input, ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'line-separator',
    templateUrl: './line-separator.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ]
})
export class LineSeparatorComponent {}
